import { connect } from 'react-redux';
import { map, path, compose, pipe, applySpec } from 'ramda';
import { reduxForm } from 'redux-form';
import { FORM_NAMES } from 'constants/forms';

import OrganizationForm from 'components/OrganizationForm/Form';

import { getPractitionersByRole } from 'store/selectors/practitioners';
import {
  RESEARCHER,
  DOCTOR,
  TECHNICIAN,
  SUPER_RESEARCHER,
  SUPER_TECHNICIAN,
} from 'constants/userRoles';
import { getSiteId, getOrganizationName } from 'store/selectors/organization';

const handleDataForCheckboxes = map(
  applySpec({
    label: item =>
      `${path(['resource', 'name', '0', 'text'], item)} (${path(['resource', 'id'], item)})`,
    name: path(['resource', 'id']),
  }),
);

const getPractitioners = role =>
  pipe(
    getPractitionersByRole(role),
    handleDataForCheckboxes,
  );

const mapStateToProps = applySpec({
  researchCoordinators: getPractitioners(RESEARCHER),
  doctors: getPractitioners(DOCTOR),
  technicians: getPractitioners(TECHNICIAN),
  superResearchCoordinators: getPractitioners(SUPER_RESEARCHER),
  superTechnicians: getPractitioners(SUPER_TECHNICIAN),
  siteId: getSiteId,
  name: getOrganizationName,
});

const withForm = reduxForm({
  form: FORM_NAMES.addOrganization,
});

export default compose(
  connect(mapStateToProps),
  withForm,
)(OrganizationForm);
